import { Autotractor } from "protos/atk/autotractor";
import { ConfigValidationResult } from "protos/portal/atk_equipment";
import { createContext } from "react";

interface RigValidationContext {
  rig: Autotractor | undefined;
  validationResult: ConfigValidationResult | undefined;
  validationResultLoading: boolean;
}

export const RigValidationContext = createContext<RigValidationContext>({
  rig: undefined,
  validationResult: undefined,
  validationResultLoading: true,
});
